import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPages, createPage, fetchPage, modifyPage, deletePageApi, changeStatus } from '../../api/pageApi';

export const getPages = createAsyncThunk('page/getPages', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchPages(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addPage = createAsyncThunk('page/addPage', async (payload, { rejectWithValue }) => {
  try {
    const response = await createPage(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getPageDetails = createAsyncThunk('page/getPageDetails', async (pageId, { rejectWithValue }) => {
  try {
    const response = await fetchPage(pageId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updatePage = createAsyncThunk('page/updatePage', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyPage(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deletePage = createAsyncThunk('page/deletePage', async (pageId, { rejectWithValue }) => {
  try {
    const response = await deletePageApi(pageId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('page/changeDefaultStatus', async (pageId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(pageId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const pageSlice = createSlice({
  name: 'page',
  initialState: {
    pages: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPages.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pages = action.payload;
      })
      .addCase(getPages.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default pageSlice.reducer;
